// @ icons
import ICON1_THEME1 from 'assets/icons/icon1-theme1.svg';
import ICON1_THEME2 from 'assets/icons/icon1-theme2.svg';
import ICON1_THEME3 from 'assets/icons/icon1-theme3.svg';
import ICON2_THEME1 from 'assets/icons/icon2-theme1.svg';
import ICON2_THEME2 from 'assets/icons/icon2-theme2.svg';
import ICON2_THEME3 from 'assets/icons/icon2-theme3.svg';
import ICON3_THEME1 from 'assets/icons/icon3-theme1.svg';
import ICON3_THEME2 from 'assets/icons/icon3-theme2.svg';
import ICON3_THEME3 from 'assets/icons/icon3-theme3.svg';
import ICON4_THEME1 from 'assets/icons/icon4-theme1.svg';
import ICON4_THEME2 from 'assets/icons/icon4-theme2.svg';
import ICON4_THEME3 from 'assets/icons/icon4-theme3.svg';
import FEATURE1_ICON_THEME1 from 'assets/icons/feature1-icon-theme1.svg';
import FEATURE1_ICON_THEME2 from 'assets/icons/feature1-icon-theme2.svg';
import FEATURE1_ICON_THEME3 from 'assets/icons/feature1-icon-theme3.svg';
import FEATURE2_ICON_THEME1 from 'assets/icons/feature2-icon-theme1.svg';
import FEATURE2_ICON_THEME2 from 'assets/icons/feature2-icon-theme2.svg';
import FEATURE2_ICON_THEME3 from 'assets/icons/feature2-icon-theme3.svg';
import FEATURE3_ICON_THEME1 from 'assets/icons/feature3-icon-theme1.svg';
import FEATURE3_ICON_THEME2 from 'assets/icons/feature3-icon-theme2.svg';
import FEATURE3_ICON_THEME3 from 'assets/icons/feature3-icon-theme3.svg';
import INFOBOX1_ICON_THEME1 from 'assets/icons/infobox1-icon-theme1.svg';
import INFOBOX1_ICON_THEME2 from 'assets/icons/infobox1-icon-theme2.svg';
import INFOBOX1_ICON_THEME3 from 'assets/icons/infobox1-icon-theme3.svg';
import INFOBOX2_ICON_THEME1 from 'assets/icons/infobox2-icon-theme1.svg';
import INFOBOX2_ICON_THEME2 from 'assets/icons/infobox2-icon-theme2.svg';
import INFOBOX2_ICON_THEME3 from 'assets/icons/infobox2-icon-theme3.svg';
import INFOBOX3_ICON_THEME1 from 'assets/icons/infobox3-icon-theme1.svg';
import INFOBOX3_ICON_THEME2 from 'assets/icons/infobox3-icon-theme2.svg';
import INFOBOX3_ICON_THEME3 from 'assets/icons/infobox3-icon-theme3.svg';

const CREDIT_CARD_ICON_KEY_WORD = 'AMAZON';
const CREDIT_CARD_ICON_KEY_WORD_SA = 'CREDIT-CARD-INFO';

const getIconInfoBox1 = theme => {
    switch (theme) {
        case '2':
            return INFOBOX1_ICON_THEME2;
        case '3':
            return INFOBOX1_ICON_THEME3;
        case '1':
        default:
            return INFOBOX1_ICON_THEME1;
    }
};
const getIconInfoBox2 = theme => {
    switch (theme) {
        case '2':
            return INFOBOX2_ICON_THEME2;
        case '3':
            return INFOBOX2_ICON_THEME3;
        case '1':
        default:
            return INFOBOX2_ICON_THEME1;
    }
};
const getIconInfoBox3 = theme => {
    switch (theme) {
        case '2':
            return INFOBOX3_ICON_THEME2;
        case '3':
            return INFOBOX3_ICON_THEME3;
        case '1':
        default:
            return INFOBOX3_ICON_THEME1;
    }
};
const getIconFeature1 = theme => {
    switch (theme) {
        case '2':
            return FEATURE1_ICON_THEME2;
        case '3':
            return FEATURE1_ICON_THEME3;
        case '1':
        default:
            return FEATURE1_ICON_THEME1;
    }
};
const getIconFeature2 = theme => {
    switch (theme) {
        case '2':
            return FEATURE2_ICON_THEME2;
        case '3':
            return FEATURE2_ICON_THEME3;
        case '1':
        default:
            return FEATURE2_ICON_THEME1;
    }
};
const getIconFeature3 = theme => {
    switch (theme) {
        case '2':
            return FEATURE3_ICON_THEME2;
        case '3':
            return FEATURE3_ICON_THEME3;
        case '1':
        default:
            return FEATURE3_ICON_THEME1;
    }
};
const getIcon1 = theme => {
    switch (theme) {
        case '2':
            return ICON1_THEME2;
        case '3':
            return ICON1_THEME3;
        case '1':
        default:
            return ICON1_THEME1;
    }
};
const getIcon2 = theme => {
    switch (theme) {
        case '2':
            return ICON2_THEME2;
        case '3':
            return ICON2_THEME3;
        case '1':
        default:
            return ICON2_THEME1;
    }
};
const getIcon3 = theme => {
    switch (theme) {
        case '2':
            return ICON3_THEME2;
        case '3':
            return ICON3_THEME3;
        case '1':
        default:
            return ICON3_THEME1;
    }
};
const getIcon4 = theme => {
    switch (theme) {
        case '2':
            return ICON4_THEME2;
        case '3':
            return ICON4_THEME3;
        case '1':
        default:
            return ICON4_THEME1;
    }
};

const getCreditCardInfoBoxes = partner => [
    {
        title: `initialAddInfoSection-boxTitle01_${partner.get('id')}`,
        content: `initialAddInfoSection-boxContent01_${partner.get('id')}`,
        img: getIconInfoBox1(partner.get('theme')),
        customClass: 'tc-box-container__box1',
    },
    {
        title: `initialAddInfoSection-boxTitle02_${partner.get('id')}`,
        content: `initialAddInfoSection-boxContent02_${partner.get('id')}`,
        img: getIconInfoBox2(partner.get('theme')),
        customClass: 'tc-box-container__box2',
    },
    {
        title: `initialAddInfoSection-boxTitle03_${partner.get('id')}`,
        content: `initialAddInfoSection-boxContent03_${partner.get('id')}`,
        img: getIconInfoBox3(partner.get('theme')),
        customClass: 'tc-box-container__box3',
    },
];

const getCreditCardAdditionalInfoFeatures = partner => [
    {
        title: `initialAddInfoSection-serviceTitle01_${partner.get('id')}`,
        content: `initialAddInfoSection-serviceContent01_${partner.get('id')}`,
        img: getIconFeature1(partner.get('theme')),
        imgAlign: 'left',
    },
    {
        title: `initialAddInfoSection-serviceTitle02_${partner.get('id')}`,
        content: `initialAddInfoSection-serviceContent02_${partner.get('id')}`,
        img: getIconFeature2(partner.get('theme')),
        imgAlign: 'right',
    },
    {
        title: `initialAddInfoSection-serviceTitle03_${partner.get('id')}`,
        content: `initialAddInfoSection-serviceContent03_${partner.get('id')}`,
        img: getIconFeature3(partner.get('theme')),
        imgAlign: 'left',
    },
];

const getCreditCardInfoFeatures = partner => [
    {
        index: 1,
        title: `initialInfoSection-featureTitle01_${partner.get('id')}`,
        content: `initialInfoSection-featureContent01_${partner.get('id')}`,
        img: getIcon1(partner.get('theme')),
    },
    {
        index: 2,
        title: `initialInfoSection-featureTitle02_${partner.get('id')}`,
        content: `initialInfoSection-featureContent02_${partner.get('id')}`,
        img: getIcon2(partner.get('theme')),
    },
    {
        index: 3,
        title: `initialInfoSection-featureTitle03_${partner.get('id')}`,
        content: `initialInfoSection-featureContent03_${partner.get('id')}`,
        img: getIcon3(partner.get('theme')),
    },
    {
        index: 4,
        title: `initialInfoSection-featureTitle04_${partner.get('id')}`,
        content: `initialInfoSection-featureContent04_${partner.get('id')}`,
        img: getIcon4(partner.get('theme')),
    },
];

export default {
    CREDIT_CARD_ICON_KEY_WORD_SA,
    CREDIT_CARD_ICON_KEY_WORD,
    getCreditCardInfoBoxes,
    getCreditCardInfoFeatures,
    getCreditCardAdditionalInfoFeatures,
};
